import React from 'react'
import {Box, Button, Container, CssBaseline, Grid,Link, makeStyles, TextField,Typography } from '@material-ui/core'
import { useDispatch } from 'react-redux';

import { useForm } from '../../hooks/useForm';
import { starLoginEmailPassword } from '../../actions/auth';
import {LogoKerunos} from '../ui/LogoKerunos.jsx'





const Copyright = () =>{
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="#">
                Keraunos SAS
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    )
}

/**
 * Style for the component
 */

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    logo: {
        marginTop: theme.spacing(1),
        width: '100%',
        ['@media (min-width:1020px)']: { // eslint-disable-line no-useless-computed-key
            width: '100%',
        },
    },
}));


export const LoginScreen = ({history}) => {

    const classes = useStyles();

    const dispatch = useDispatch();

    /*
    Allows you to initialize the variables for later use 
    */
    const initialState ={
        email:'',
        password: ''
    }

    //hook useForm
    const[formValues,handleInputChange] = useForm(initialState)
    const{email,password}=formValues


    /**
     * Function that allows you to login
     * @param {Event} e 
     */
    const handleLogin = (e) =>{
        e.preventDefault();
        dispatch(starLoginEmailPassword(email,password))

        history.push('/')
    }

    return (
        
        <Container component="main" maxWidth="xs">
            <CssBaseline/>

            <div className={classes.paper}>


                <Typography component="h1" variant="h5" style={{ fontStyle: 'arial'}}>Keraunos Life Preserver</Typography>

                <form className={classes.form} onSubmit={handleLogin}>
                    <TextField value={email} onChange={handleInputChange} variant="outlined" margin="normal" id="email" name="email" autoComplete="email" label="Usuario" autoFocus fullWidth required/>
                    <TextField value={password} onChange={handleInputChange} variant="outlined" margin="normal" id="password" name="password" autoComplete="current-password" label="Contraseña"  type="password" fullWidth required/>

                    <Button variant="contained" color="primary" type="submit" className={classes.submit} fullWidth>Entrar</Button>

                    <Grid container>
                     <Grid item xs>
                        <Link href="#" variant="body2"></Link>
                     </Grid>

                    </Grid>
                </form>
               
               
                <div className={classes.logo}>
                    <LogoKerunos/>
                </div>


            </div>

            <Box mt={8}>
                <Copyright/>
            </Box>
            
        </Container>
        
    )
}
